if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
          this.enableMobileSwipe();

      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      enableMobileSwipe() {
  // mobile/touch only
  const isTouch =
    'ontouchstart' in window ||
    (navigator.maxTouchPoints && navigator.maxTouchPoints > 0);

  if (!isTouch || this._swipeBound) return;
  this._swipeBound = true;

  const container = this.querySelector('[role="document"]');
  if (!container) return;

  let startX = 0;
  let startY = 0;

  container.addEventListener('touchstart', (e) => {
    const t = e.touches[0];
    startX = t.clientX;
    startY = t.clientY;
  }, { passive: true });

  container.addEventListener('touchend', (e) => {
    const t = e.changedTouches[0];
    const dx = t.clientX - startX;
    const dy = t.clientY - startY;

    // ignore mostly vertical swipes
    if (Math.abs(dy) > Math.abs(dx)) return;

    // threshold
    if (Math.abs(dx) < 40) return;

    const items = Array.from(this.querySelectorAll('[data-media-id]'));
    if (!items.length) return;

    const currentId = this.dataset.activeMediaId;
    let idx = items.findIndex((el) => el.getAttribute('data-media-id') === currentId);
    if (idx === -1) idx = 0;

    // swipe left = next, swipe right = prev
    idx = dx < 0 ? Math.min(idx + 1, items.length - 1) : Math.max(idx - 1, 0);

    this.dataset.activeMediaId = items[idx].getAttribute('data-media-id');
    this.openedBy = { getAttribute: () => this.dataset.activeMediaId }; // minimal shim
    this.showActiveMedia();
  }, { passive: true });
}

    }
  );
}
